import {
  CLIENT_SET,
  CLIENT_UNSET,
  CATEGORY_SET,
  SETTING_SET,
  LOGIN_SET,
  LOGIN_UNSET,
  AUTH_SET,
  AUTH_UNSET,
  RESET_SET,
  RESET_UNSET,
  SYMBOL_MINIMIZE_SET,
  TYPE_INDEX_SET,
  CASH_OUT_SET,
  ORD_COND_SET,
  SYMBOL_ACTIVE_SET,
  CONFIG_REQUESTING,
  CONFIG_REQUEST_SUCCESS,
  CONFIG_REQUEST_ERROR,
  CATEGORY_REQUESTING,
  CATEGORY_REQUEST_SUCCESS,
  CATEGORY_REQUEST_ERROR,
  AUTHEN_SET,
  CHANGE_PASS_UNSET,
  CHANGE_PASS_SET,
  INDEX_HIDE_SET,
  DBL_PRICE_SET,
  CTLG_ID_EDIT_SET,
  SYMBOL_ADD,
  CHANGE_USER_SET,
  CHANGE_USER_UNSET,
  FULL_TRADING_SET,
  FULL_TRADING_UNSET,
  OBJ_TRADING_SET,
  OBJ_TRADING_UNSET,
  CHANGE_BANK_SET,
  CHANGE_BANK_UNSET,
  SYMBOL_SCROLL,
} from './constants';

const initialSate = {
  id: null,
  token: null,
  reqLogin: false,
  reqAuth: false,
  reqReset: false,
  reqChangePass: false,
  reqChangeUser: false,
  reqChangeBank: false,
  reqFullTrading: false,
  reqLostSession: false,
  objTrading: null,
  toast: null,
  setting: { symbolMinimize: [], indHid: [] },
  symbolActive: null,
  symbolDel: null,
  symbolAdd: null,
  symbolScroll: null,
  ctlgIdEdit: null,
  auth: {
    isVerified: false,
    type: null,
    token: null,
  },
  pin: null,
  savePin: false,
  cashOut: false,
  ordCond: false,
  dblPri: null,

  config: null,
  configRequesting: false,
  configSuccessful: false,
  configErrors: [],

  category: null,
  categoryRequesting: false,
  categorySuccessful: false,
  categoryErrors: [],
};

const reducer = function clientReducer(state = initialSate, action) {
  switch (action.type) {
    case 'REQUEST_PRIVATE_FALSE':
    case 'SHOW_TOAST':
      console.log(action);
      return {
        ...state,
        toast: action.resData,
      };

    case 'SYMBOL_DEL':
      return {
        ...state,
        symbolDel: action.symbol,
      };

    case SYMBOL_ADD:
      return {
        ...state,
        symbolAdd: action.symbol,
      };

    case SYMBOL_SCROLL:
      return {
        ...state,
        symbolScroll: action.symbol,
      };

    case 'CLEAR_LOST_SESSION':
      return {
        ...state,
        reqLostSession: false,
      };

    case 'INVALID_SESSION':
      return {
        ...state,
        id: null,
        token: null,
        reqLostSession: true,
        pin: null,
        savePin: false,
        auth: {
          isVerified: false,
          type: null,
          token: null,
        },
        config: null,
        configRequesting: false,
        configSuccessful: false,
        configErrors: [],
      };
    case 'LOG_OUT':
    case CLIENT_UNSET:
      return {
        ...state,
        id: null,
        token: null,
        pin: null,
        savePin: false,
        auth: {
          isVerified: false,
          type: null,
          token: null,
        },
        config: null,
        configRequesting: false,
        configSuccessful: false,
        configErrors: [],
      };

    case CLIENT_SET:
      return {
        ...state,
        id: action.token.user,
        token: action.token,
      };

    case AUTHEN_SET:
      return {
        ...state,
        auth: action.auth,
      };

    case CATEGORY_SET:
      console.log(action);
      return {
        ...state,
        category: action.category,
      };

    case SETTING_SET:
      console.log(action);
      return {
        ...state,
        setting: action.setting,
      };

    case LOGIN_SET:
      return {
        ...state,
        reqLogin: true,
      };

    case LOGIN_UNSET:
      return {
        ...state,
        reqLogin: false,
      };

    case AUTH_SET:
      return {
        ...state,
        reqAuth: true,
      };

    case AUTH_UNSET:
      return {
        ...state,
        reqAuth: false,
      };

    case RESET_SET:
      return {
        ...state,
        reqReset: true,
      };

    case RESET_UNSET:
      return {
        ...state,
        reqReset: false,
      };

    case CHANGE_PASS_SET:
      return {
        ...state,
        reqChangePass: true,
      };

    case CHANGE_PASS_UNSET:
      return {
        ...state,
        reqChangePass: false,
      };

    case CHANGE_USER_SET:
      return {
        ...state,
        reqChangeUser: true,
      };

    case CHANGE_USER_UNSET:
      return {
        ...state,
        reqChangeUser: false,
      };

    case CHANGE_BANK_SET:
      return {
        ...state,
        reqChangeBank: true,
      };

    case CHANGE_BANK_UNSET:
      return {
        ...state,
        reqChangeBank: false,
      };

    case FULL_TRADING_SET:
      return {
        ...state,
        reqFullTrading: true,
      };

    case FULL_TRADING_UNSET:
      return {
        ...state,
        reqFullTrading: false,
      };

    case OBJ_TRADING_SET:
      return {
        ...state,
        objTrading: action.data,
      };

    case OBJ_TRADING_UNSET:
      return {
        ...state,
        objTrading: null,
      };

    case TYPE_INDEX_SET:
      return {
        ...state,
        setting: { ...state.setting, typeIndex: action.data },
      };

    case INDEX_HIDE_SET:
      return {
        ...state,
        setting: { ...state.setting, indHid: action.data },
      };

    case CASH_OUT_SET:
      return {
        ...state,
        cashOut: action.data,
      };

    case ORD_COND_SET:
      return {
        ...state,
        ordCond: action.data,
      };

    case DBL_PRICE_SET:
      return {
        ...state,
        dblPri: action.data,
      };

    case CTLG_ID_EDIT_SET:
      return {
        ...state,
        ctlgIdEdit: action.data,
      };

    case SYMBOL_MINIMIZE_SET:
      return {
        ...state,
        setting: { ...state.setting, symbolMinimize: [...action.data] },
        // symbolMinimize: action.data,
      };

    case SYMBOL_ACTIVE_SET:
      return {
        ...state,
        symbolActive: action.data,
      };

    case CONFIG_REQUESTING:
      return {
        ...state,
        configRequesting: false,
        configSuccessful: false,
        configErrors: [],
      };

    case CONFIG_REQUEST_SUCCESS:
      return {
        ...state,
        config: action.config,
        configRequesting: false,
        configSuccessful: true,
        configErrors: [],
      };

    case CONFIG_REQUEST_ERROR:
      return {
        ...state,
        configRequesting: false,
        configSuccessful: false,
        configErrors: [
          ...[
            {
              body: action.error.toString(),
              time: new Date(),
            },
          ],
        ],
      };

    case CATEGORY_REQUESTING:
      return {
        ...state,
        categoryRequesting: false,
        categorySuccessful: false,
        categoryErrors: [],
      };

    case CATEGORY_REQUEST_SUCCESS:
      return {
        ...state,
        category: action.category,
        categoryRequesting: false,
        categorySuccessful: true,
        categoryErrors: [],
      };

    case CATEGORY_REQUEST_ERROR:
      return {
        ...state,
        categoryRequesting: false,
        categorySuccessful: false,
        categoryErrors: [
          ...[
            {
              body: action.error.toString(),
              time: new Date(),
            },
          ],
        ],
      };

    default:
      return state;
  }
};

export default reducer;
